export const ReportPages = Object.freeze({
    Overview: "Overview",
    Detailed: "Detailed View",
    Sweeps: "Sweeps"
});

export const UserRoles = Object.freeze({
    Producer: "Producer",
    Principal: "IA Principal"
});

export const colors = ["#004B9B", "#B990F9", "#99D4F2", "#0B2455"]
export const extendedColors = ["#004B9B", "#B990F9", "#0B2455", "#99D4F2", "#6425AD"]

export function abbreviateNumber(num) {
    return new Intl.NumberFormat('en-US', {
        notation: "compact",
        compactDisplay: "short",
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
    }).format(num);
};

export function capitalizeFirst(name) {
    return name?.charAt(0).toUpperCase() + name?.slice(1).toLowerCase();
}

export function switchViewLinkText(title) {
    if (title === ReportPages.Overview) {
        return 'Switch to Detailed View'
    } else if (title === ReportPages.Detailed) {
        return 'Switch to Overview'
    }
}

export function monthYearStringToDate(monthYearString) {
    if (typeof monthYearString === 'string') {
        const [year, month] = monthYearString.split('-');
        return new Date(year, month - 1);
    }
    return monthYearString;
}

export const overviewNewBusinessFilters = [
    {
        value: "RatedStates",
        label: "Rated State",
        optionsKey: "RatedState",
    }
]

export const detailedViewFilters = [
    {
        value: "RatedState",
        label: "Rated State",
        optionsKey: "RatedState",
    },
    {
        value: "BranchSourceOfBusiness",
        label: "Agency Branch",
        optionsKey: "AgencyBranchNames",
    },
    {
        value: "AgentSourceOfBusiness",
        label: "Producer",
        optionsKey: "AgentProfiles",
    },
    {
        value: "LineOfBusiness",
        label: "LOB",
        optionsKey: "LineOfBusiness",
    },
    {
        value: "ProductGroup",
        label: "Product",
        optionsKey: "ProductGroups",
    },
    {
        value: "PpaRiskSegment",
        label: "PPA Risk Segment",
        optionsKey: "PpaRiskSegment",
    },
    {
        value: "CommercialBusSegment",
        label: "Commercial Business Segment",
        optionsKey: "CommBusinessSegment"
    },
];

export const sweepsFilters = [
    {
        value: "LineOfBusiness",
        label: "Line of Business",
        optionsKey: "LineOfBusiness"
    },
    {
        value: "TransactionStatus",
        label: "Transaction Status",
        optionsKey: "TransactionStatuses"
    },
    {
        value: "NSF",
        label: "NSF",
        optionsKey: "NSF"
    }
]